import { browserHistory } from "react-router";

import {
	GET_OFFER_REQUEST,
	GET_OFFER_FAIL,
	GET_OFFER_SUCCESS,
	GET_QUOTATION_REQUEST,
	GET_QUOTATION_FAIL,
	GET_QUOTATION_SUCCESS,
	FILTER_BY_BRAND,
	FILTER_BY_A2P,
	FILTER_BY_PROTECTED
} from "../app/ActionTypes";

import {
	getOffer,
	getQuotation
} from "../webAPI/MKSService";

export function getOfferRequest(projectId) {
	return function (dispatch) {
		dispatch({
			type: GET_OFFER_REQUEST
		});
		return getOffer(projectId).then(
			(error) => {
				dispatch({
					type: GET_OFFER_FAIL,
					error
				});
			},
			(result) => {
				let brands = ["TOUTES"];
				result.forEach(res => {
					let notIn = brands.indexOf(res.brand.name) === -1;
					if(notIn) {
						brands.push(res.brand.name);
					}
				});
				dispatch({
					type: "GET_OFFER_SUCCESS",
					result,
					brands
				});
			}
		);
	};
}

export function getQuotationRequest(projectId, productLineId) {
	return function (dispatch) {
		dispatch({
			type: GET_QUOTATION_REQUEST,
			productLineId
		});
		return getQuotation(projectId, productLineId).then(
			(error) => {
				dispatch({
					type: GET_QUOTATION_FAIL,
					productLineId,
					error
				});
			},
			(result) => {
				dispatch({
					type: GET_QUOTATION_SUCCESS,
					result
				});

				browserHistory.push("/app/project/" + encodeURIComponent(projectId) + "/offer/" + result.estimate_number);
			}
		);
	}
}

export const filterByBrand = (value) => (dispatch) => {
	dispatch({
		type: FILTER_BY_BRAND,
		value
	});
}

export const filterByA2p = (value) => (dispatch) => {
	dispatch({
		type: FILTER_BY_A2P,
		value
	});
}

export const filterByProtected = (value) => (dispatch) => {
	dispatch({
		type: FILTER_BY_PROTECTED,
		value
	});
}



// WEBPACK FOOTER //
// ./src/js/offer/offerActions.js